var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{attrs:{"variant":"danger","size":"30"}},[_c('feather-icon',{attrs:{"icon":"TrashIcon","size":"20"},on:{"click":function($event){return _vm.$emit('click')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }